/*------------------------------------*\
    MODULES
\*------------------------------------*/
import { pwStrength } from 'pw-strength'

/*------------------------------------*\
    PASSWORD VALIDATE
\*------------------------------------*/
class PasswordValidate {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;

        // Elements
        self.password = self.elem.querySelector('[data-password]');
        self.meter = self.elem.querySelector('[data-password-strength-meter]');
        self.submitBtn = self.elem.querySelector('[data-submit]');

        // Meter colors
        self.progressColors = ['bg-danger', 'bg-warning', 'bg-success'];
    }

    init() {
        let self = this;

        self.password.addEventListener('input', evt => {
            // Calculate the stength of the entered password
            let strength = pwStrength(evt.target.value);

            // Set meter length
            self.meter.style.width = strength + '%';

            // Set meter color and text
            if (strength < 33) {
                self.setProgressBarColor('bg-danger');
                self.meter.textContent = 'Weak';
            } else if (strength < 66) {
                self.setProgressBarColor('bg-warning');
                self.meter.textContent = 'Better';
            } else if (strength < 80) {
                self.setProgressBarColor('bg-success');
                self.meter.textContent = 'Strong';
            } else {
                self.setProgressBarColor('bg-success');
                self.meter.textContent = 'Very strong';
            }

            // Enable/disable submit button
            if (strength < 66) {
                self.submitBtn.disabled = true;
            } else {
                self.submitBtn.disabled = false;
            }
        });
    }

    setProgressBarColor(activeColor) {
        let self = this;

        // Remove all color classes
        self.progressColors.forEach(color => {
            self.meter.classList.remove(color);
        });

        // Set active color class
        self.meter.classList.add(activeColor);
    }
}

export default PasswordValidate;
